import { create } from "zustand";

type ChatbarPill = { sender?: string; text: string; shareToken?: string } | null;

export type StartAgentParams = {
  agentId?: string;
  agentName?: string;
  context?: any;
  // A customer question delivered into the conversation and answered by the agent.
  initialQuestion?: string;
  // A greeting shown first FROM the agent (static bot message, not answered).
  initialMessage?: string;
} | null;

type ChatbarNotificationState = {
  pill: ChatbarPill;
  setPill: (pill: ChatbarPill) => void;
  clear: () => void;
  // Bumped whenever the host SDK reports a click outside the chatbar. ChatbarView
  // watches this counter to collapse the open panel — a non-blocking
  // outside-click-to-close (the SDK only listens, it never blocks host clicks).
  closeRequestId: number;
  requestClose: () => void;
  // Bumped whenever the host SDK calls Gleap.startAgent(). ChatbarView watches
  // this counter to open the panel and start a fresh conversation with
  // startAgentParams (the requested agent + optional initial message).
  startAgentRequestId: number;
  startAgentParams: StartAgentParams;
  requestStartAgent: (params: StartAgentParams) => void;
};

export const useChatbarNotificationStore = create<ChatbarNotificationState>()((set) => ({
  pill: null,
  setPill: (pill) => set({ pill }),
  clear: () => set({ pill: null }),
  closeRequestId: 0,
  requestClose: () => set((s) => ({ closeRequestId: s.closeRequestId + 1 })),
  startAgentRequestId: 0,
  startAgentParams: null,
  requestStartAgent: (params) =>
    set((s) => ({
      startAgentParams: params,
      startAgentRequestId: s.startAgentRequestId + 1,
    })),
}));
